var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtLifeinsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M20.208.405C18.412 2.828 5.658 8 1 8c-.552 0-1 .448-1 1v19c0 4.267 3.613 8.752 9.61 13.26l.378.282c4 2.957 9.533 6.102 10.767 6.414.161.04.33.04.491 0 1.102-.28 6.69-3.566 10.76-6.543l.752-.556C38.544 36.51 42 32.494 42 29V9c0-.552-.448-1-1-1C36.02 8 23.675 2.915 21.814.405c-.4-.54-1.207-.54-1.606 0zm.795 2.012l.093.08C24.56 5.396 34.471 9.41 39.893 9.942L40 9.95V29c0 2.742-3.463 6.623-9.174 10.799-2.154 1.575-4.507 3.103-6.74 4.415l-.684.398c-.947.542-1.786.993-2.26 1.229l-.15.072-.061-.027c-.53-.245-1.616-.802-2.78-1.457l-.251-.141c-2.251-1.28-4.585-2.774-6.722-4.355l-.372-.276C5.288 35.506 2 31.429 2 28V9.945l.056-.005c5.22-.539 15.4-4.61 18.876-7.461l.07-.062z",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4C5F2",
    d: "M33 24c0 6.627-5.373 12-12 12S9 30.627 9 24c0-6.628 5.373-12 12-12s12 5.372 12 12",
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5593E7",
    d: "M21 17c1.861 0 3.6 1.505 3.6 3.36v1.679c0 1.11-.62 2.092-1.517 2.704 2.283.705 4.417 2.378 4.417 3.814V29.7c0 .828-.672 1.5-1.5 1.5H16c-.828 0-1.5-.672-1.5-1.5v-1.143c0-1.436 2.134-3.11 4.417-3.815-.897-.61-1.517-1.594-1.517-2.703V20.36c0-1.855 1.739-3.36 3.6-3.36z",
    transform: "translate(3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtLifeinsurance);
export default __webpack_public_path__ + "static/media/art-lifeinsurance.ff07ca7c7cc6dc31bb233dd4f2c7bff2.svg";
export { ForwardRef as ReactComponent };